import React from "react"

import { Container, Row, Col } from "react-bootstrap"

import RightSidebar from "../right-sidebar"
import Title from "./title"
import "./detail.scss"
import RelatedArticles from "../related-articles/related-articles"
import SEO from "../../seo"
import StatsGa from "./stats-ga"
import CombinationOfAcfs from "../../acf-blocks/combination-of-acfs/combination-of-acfs"

const BlogDetail = ({ articles }) => {
  const data = articles[0]?.acf?.content

  return (
    <div className="blog-detail">
      <SEO
        title={articles[0]?.title?.rendered}
        meta_fields={articles[0]?.acf?.seo_metadata[0]}
      />
      <Container>
        <Row className="mb-md-1">
          <Col lg="8" className="pr-lg-5">
            <Title articles={articles} />
            <StatsGa />
            <CombinationOfAcfs isBlog data={data} />
          </Col>
          <Col lg="4">
            <RightSidebar />
          </Col>
        </Row>
        <RelatedArticles
          categories={articles[0]?.categories}
          slug={articles[0]?.slug}
        />
      </Container>
    </div>
  )
}

export default BlogDetail
